import { ChangeEvent, FC, ReactElement } from 'react';

import classNames from 'classnames';

import { InputProps } from '../../../components';
import { FormImageOption } from '../../../entities/@forms/Form/Form';
import { InputLabelProps, InputLabelWrapper, Radio } from '../..';

import './RadioList.scss';

interface RadioListProps extends InputLabelProps, Omit<InputProps, 'onChange'> {
    isLoading?: boolean;
    id?: string;
    name: string;
    value: string;
    options: FormImageOption[];
    onChange: (value: string) => void;
    className?: string;
    radioClassName?: string;
}

export const RadioList: FC<RadioListProps> = ({
    isLoading,
    id,
    label,
    hideLabel,
    required,
    value,
    options,
    tooltip,
    error,
    onChange,
    className = '',
    radioClassName = '',
    ...inputProps
}): ReactElement => {
    const handleOnRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.currentTarget.value);
    };

    const radioListOptionWrapperClassNames = classNames('radio-list__option-wrapper', {
        'radio-list__option-wrapper--has-error': error,
    });

    return (
        <div id={id} className={`radio-list ${className}`}>
            <InputLabelWrapper
                hideLabel={hideLabel}
                label={label}
                required={required}
                tooltip={tooltip}
                error={error}
                labelClassName="radio-list__label"
            >
                <div className={radioListOptionWrapperClassNames}>
                    {options.map(option => (
                        <Radio
                            {...inputProps}
                            disabled={isLoading}
                            key={option.value}
                            required={required}
                            selected={value}
                            option={option}
                            onChange={handleOnRadioChange}
                            className={`radio-list__radio ${radioClassName}`}
                        />
                    ))}
                </div>
            </InputLabelWrapper>
        </div>
    );
};
